import { TranslationKeys } from 'types/TranslationKeys'

export interface NewsCardProps {
  title: string
  description: string
  author: string
  category: string
  image: string
  authorImage: string | null
  url: string
  date: string
  isAr: boolean
  tagsIds?: string
  t: (key: TranslationKeys) => string
}

export const useNewsCard = (props: NewsCardProps) => {
  return {
    ...props,
  }
}
